import React, { useContext } from "react";

export const SectionsFilterContext = React.createContext({});

export function useSectionsFilter() {
    return useContext(SectionsFilterContext);
}
